const MAX_NUMBER_OF_APPS = 3;

export default function formatAppsWithLimit(uniqueApps: string[]) {
  const uniqueAppsLength = uniqueApps.length;

  if (uniqueAppsLength <= MAX_NUMBER_OF_APPS) {
    return uniqueApps;
  }

  const numberOfMiddleSteps = uniqueAppsLength - 2;

  const firstApp = uniqueApps[0];
  const middleApp = numberOfMiddleSteps;
  const lastApp = uniqueApps[uniqueAppsLength - 1];

  return [firstApp, middleApp, lastApp];
}
